<template>
  <div class="page-content">
    <div class="contenter">
      <el-tabs v-model="activeName" type="card" @tab-click="handleTabChange" :before-leave='handleBeforeLeave'>
        <el-tab-pane label="趋势分析" name="trendAnalysis">
          <trend-analysis ref="trendAnalysis"></trend-analysis>
        </el-tab-pane>
        <el-tab-pane label="数据报表" name="dataReport">
          <data-report ref="dataReport"></data-report>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import trendAnalysis from './trendAnalysis.vue'
import dataReport from './dataReport.vue'
export default {
  name: 'runAnalysis',
  components: {
    trendAnalysis,
    dataReport
  },
  data () {
    return {
      activeName: 'trendAnalysis'
    }
  },
  created () {},
  methods: {
    handleBeforeLeave (newTab, oldTab) {
      // this.$refs[oldTab].handleBeforeLeave()
    }
  }
}
</script>

<style lang="scss" scoped>
.page-content {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  color: #333;
  padding: 16px;
  .contenter {
    width: 100%;
    height: 100%;
    padding: 8px;
    box-sizing: border-box;
    background-color: #fff;
  }
}

.el-tabs {
  height: 100%;
  ::v-deep .el-tabs__content{
    height: calc(100% - 60px);
  }
  .el-tab-pane {
    height: 100%;
  }
}
</style>
